var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g, _path47, _g2, _path48, _path49, _g3, _path50, _path51, _g4, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSceneryLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 259,
    viewBox: "0 0 420 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M539.691 174.862C249.552 165.013 -55.4482 170.026 -171.681 173.764L-175.475 236.38L540.606 229.156C661.192 215.162 829.829 184.712 539.691 174.862Z",
    fill: "#FBCB84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7515 100.779C91.1876 100.684 90.9084 97.279 90.5892 95.5882L86.9989 94.8804C86.6 95.9027 85.6825 98.2305 85.2038 99.363C84.6054 100.779 87.9564 100.896 89.7515 100.779Z",
    fill: "#492E0D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7515 100.779C91.1876 100.684 90.9084 97.279 90.5892 95.5882L86.9989 94.8804C86.6 95.9027 85.6825 98.2305 85.2038 99.363C84.6054 100.779 87.9564 100.896 89.7515 100.779Z",
    fill: "#492E0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7515 100.779C91.1876 100.684 90.9084 97.279 90.5892 95.5882L86.9989 94.8804C86.6 95.9027 85.6825 98.2305 85.2038 99.363C84.6054 100.779 87.9564 100.896 89.7515 100.779Z",
    fill: "#492E0D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7515 100.779C91.1876 100.684 90.9084 97.279 90.5892 95.5882L86.9989 94.8804C86.6 95.9027 85.6825 98.2305 85.2038 99.363C84.6054 100.779 87.9564 100.896 89.7515 100.779Z",
    fill: "#492E0D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1025 104.583C90.5264 104.373 89.9743 101.001 89.5203 99.3417L85.8847 98.9248C85.5693 99.9759 84.8419 102.37 84.4558 103.537C83.9731 104.996 87.3227 104.844 89.1025 104.583Z",
    fill: "#492E0D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1025 104.583C90.5264 104.373 89.9743 101.001 89.5203 99.3417L85.8847 98.9248C85.5693 99.9759 84.8419 102.37 84.4558 103.537C83.9731 104.996 87.3227 104.844 89.1025 104.583Z",
    fill: "#492E0D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1025 104.583C90.5264 104.373 89.9743 101.001 89.5203 99.3417L85.8847 98.9248C85.5693 99.9759 84.8419 102.37 84.4558 103.537C83.9731 104.996 87.3227 104.844 89.1025 104.583Z",
    fill: "#492E0D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1025 104.583C90.5264 104.373 89.9743 101.001 89.5203 99.3417L85.8847 98.9248C85.5693 99.9759 84.8419 102.37 84.4558 103.537C83.9731 104.996 87.3227 104.844 89.1025 104.583Z",
    fill: "#492E0D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5209 109.042C90.1175 108.807 89.4984 105.027 88.9893 103.165L84.9127 102.698C84.559 103.877 83.7433 106.561 83.3103 107.87C82.7691 109.506 86.5251 109.336 88.5209 109.042Z",
    fill: "#492E0D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5209 109.042C90.1175 108.807 89.4984 105.027 88.9893 103.165L84.9127 102.698C84.559 103.877 83.7433 106.561 83.3103 107.87C82.7691 109.506 86.5251 109.336 88.5209 109.042Z",
    fill: "#492E0D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5209 109.042C90.1175 108.807 89.4984 105.027 88.9893 103.165L84.9127 102.698C84.559 103.877 83.7433 106.561 83.3103 107.87C82.7691 109.506 86.5251 109.336 88.5209 109.042Z",
    fill: "#492E0D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5209 109.042C90.1175 108.807 89.4984 105.027 88.9893 103.165L84.9127 102.698C84.559 103.877 83.7433 106.561 83.3103 107.87C82.7691 109.506 86.5251 109.336 88.5209 109.042Z",
    fill: "#492E0D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0018 113.871C89.702 113.621 89.0428 109.595 88.5007 107.613L84.1595 107.115C83.7828 108.37 82.9142 111.229 82.4532 112.623C81.8768 114.365 85.8765 114.184 88.0018 113.871Z",
    fill: "#492E0D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0018 113.871C89.702 113.621 89.0428 109.595 88.5007 107.613L84.1595 107.115C83.7828 108.37 82.9142 111.229 82.4532 112.623C81.8768 114.365 85.8765 114.184 88.0018 113.871Z",
    fill: "#492E0D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0018 113.871C89.702 113.621 89.0428 109.595 88.5007 107.613L84.1595 107.115C83.7828 108.37 82.9142 111.229 82.4532 112.623C81.8768 114.365 85.8765 114.184 88.0018 113.871Z",
    fill: "#492E0D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0018 113.871C89.702 113.621 89.0428 109.595 88.5007 107.613L84.1595 107.115C83.7828 108.37 82.9142 111.229 82.4532 112.623C81.8768 114.365 85.8765 114.184 88.0018 113.871Z",
    fill: "#492E0D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5689 119.868C89.5466 119.577 88.7798 114.894 88.1491 112.589L83.0994 112.01C82.6612 113.469 81.6508 116.795 81.1145 118.416C80.4441 120.443 85.0967 120.232 87.5689 119.868Z",
    fill: "#492E0D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5689 119.868C89.5466 119.577 88.7798 114.894 88.1491 112.589L83.0994 112.01C82.6612 113.469 81.6508 116.795 81.1145 118.416C80.4441 120.443 85.0967 120.232 87.5689 119.868Z",
    fill: "#492E0D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5689 119.868C89.5466 119.577 88.7798 114.894 88.1491 112.589L83.0994 112.01C82.6612 113.469 81.6508 116.795 81.1145 118.416C80.4441 120.443 85.0967 120.232 87.5689 119.868Z",
    fill: "#492E0D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5689 119.868C89.5466 119.577 88.7798 114.894 88.1491 112.589L83.0994 112.01C82.6612 113.469 81.6508 116.795 81.1145 118.416C80.4441 120.443 85.0967 120.232 87.5689 119.868Z",
    fill: "#492E0D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4631 125.836C89.5605 125.34 88.3011 120.38 87.4093 117.963L81.931 117.81C81.5961 119.419 80.8201 123.085 80.3948 124.877C79.8632 127.116 84.8413 126.457 87.4631 125.836Z",
    fill: "#492E0D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4631 125.836C89.5605 125.34 88.3011 120.38 87.4093 117.963L81.931 117.81C81.5961 119.419 80.8201 123.085 80.3948 124.877C79.8632 127.116 84.8413 126.457 87.4631 125.836Z",
    fill: "#492E0D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4631 125.836C89.5605 125.34 88.3011 120.38 87.4093 117.963L81.931 117.81C81.5961 119.419 80.8201 123.085 80.3948 124.877C79.8632 127.116 84.8413 126.457 87.4631 125.836Z",
    fill: "#492E0D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4631 125.836C89.5605 125.34 88.3011 120.38 87.4093 117.963L81.931 117.81C81.5961 119.419 80.8201 123.085 80.3948 124.877C79.8632 127.116 84.8413 126.457 87.4631 125.836Z",
    fill: "#492E0D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9245 132.961C90.2619 132.248 88.48 126.727 87.2969 124.056L81.0874 124.278C80.8244 126.123 80.2102 130.326 79.858 132.384C79.4177 134.956 85.0028 133.852 87.9245 132.961Z",
    fill: "#492E0D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9245 132.961C90.2619 132.248 88.48 126.727 87.2969 124.056L81.0874 124.278C80.8244 126.123 80.2102 130.326 79.858 132.384C79.4177 134.956 85.0028 133.852 87.9245 132.961Z",
    fill: "#492E0D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9245 132.961C90.2619 132.248 88.48 126.727 87.2969 124.056L81.0874 124.278C80.8244 126.123 80.2102 130.326 79.858 132.384C79.4177 134.956 85.0028 133.852 87.9245 132.961Z",
    fill: "#492E0D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9245 132.961C90.2619 132.248 88.48 126.727 87.2969 124.056L81.0874 124.278C80.8244 126.123 80.2102 130.326 79.858 132.384C79.4177 134.956 85.0028 133.852 87.9245 132.961Z",
    fill: "#492E0D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M88.065 140.215C90.504 139.471 88.6446 133.71 87.4101 130.923L80.9307 131.154C80.6562 133.079 80.0154 137.466 79.6478 139.613C79.1884 142.297 85.0162 141.144 88.065 140.215Z",
    fill: "#492E0D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M88.065 140.215C90.504 139.471 88.6446 133.71 87.4101 130.923L80.9307 131.154C80.6562 133.079 80.0154 137.466 79.6478 139.613C79.1884 142.297 85.0162 141.144 88.065 140.215Z",
    fill: "#492E0D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M88.065 140.215C90.504 139.471 88.6446 133.71 87.4101 130.923L80.9307 131.154C80.6562 133.079 80.0154 137.466 79.6478 139.613C79.1884 142.297 85.0162 141.144 88.065 140.215Z",
    fill: "#492E0D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M88.065 140.215C90.504 139.471 88.6446 133.71 87.4101 130.923L80.9307 131.154C80.6562 133.079 80.0154 137.466 79.6478 139.613C79.1884 142.297 85.0162 141.144 88.065 140.215Z",
    fill: "#492E0D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5336 148.526C91.1151 147.739 89.1471 141.641 87.8404 138.691L80.9822 138.936C80.6917 140.973 80.0134 145.616 79.6244 147.889C79.1381 150.73 85.3066 149.51 88.5336 148.526Z",
    fill: "#492E0D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5336 148.526C91.1151 147.739 89.1471 141.641 87.8404 138.691L80.9822 138.936C80.6917 140.973 80.0134 145.616 79.6244 147.889C79.1381 150.73 85.3066 149.51 88.5336 148.526Z",
    fill: "#492E0D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5336 148.526C91.1151 147.739 89.1471 141.641 87.8404 138.691L80.9822 138.936C80.6917 140.973 80.0134 145.616 79.6244 147.889C79.1381 150.73 85.3066 149.51 88.5336 148.526Z",
    fill: "#492E0D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5336 148.526C91.1151 147.739 89.1471 141.641 87.8404 138.691L80.9822 138.936C80.6917 140.973 80.0134 145.616 79.6244 147.889C79.1381 150.73 85.3066 149.51 88.5336 148.526Z",
    fill: "#492E0D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3212 157.417C91.309 156.844 89.8351 149.774 88.7247 146.311L81.0091 145.763C80.4389 148.011 79.1215 153.133 78.4127 155.634C77.5268 158.759 84.5865 158.132 88.3212 157.417Z",
    fill: "#492E0D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3212 157.417C91.309 156.844 89.8351 149.774 88.7247 146.311L81.0091 145.763C80.4389 148.011 79.1215 153.133 78.4127 155.634C77.5268 158.759 84.5865 158.132 88.3212 157.417Z",
    fill: "#492E0D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3212 157.417C91.309 156.844 89.8351 149.774 88.7247 146.311L81.0091 145.763C80.4389 148.011 79.1215 153.133 78.4127 155.634C77.5268 158.759 84.5865 158.132 88.3212 157.417Z",
    fill: "#492E0D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3212 157.417C91.309 156.844 89.8351 149.774 88.7247 146.311L81.0091 145.763C80.4389 148.011 79.1215 153.133 78.4127 155.634C77.5268 158.759 84.5865 158.132 88.3212 157.417Z",
    fill: "#492E0D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7027 101.218C93.4391 101.218 91.4688 97.8491 90.5166 96.1645C85.7192 95.1391 79.6399 90.869 93.7027 81.9918C107.766 73.1147 120.217 81.9552 124.685 87.4851C120.378 83.4421 112.709 83.237 109.413 83.6398C109.501 83.8156 109.523 84.1525 109.523 84.299C105.041 83.6838 102.748 84.7019 102.162 85.2878C101.459 86.6941 102.162 87.0457 102.602 87.0457C106.381 86.8699 110.695 89.6092 112.38 91.0008C112.116 90.9129 111.904 91.1839 111.831 91.3304C117.456 95.1977 119.741 99.5337 120.18 101.218H119.631C121.301 105.613 120.327 108.836 119.631 109.898C119.367 106.558 116.591 102.72 115.236 101.218C115.412 101.57 115.163 102.317 115.017 102.647C115.017 101.943 110.402 97.7392 108.095 95.725C108.271 96.3403 108.168 97.0068 108.095 97.2632C102.822 93.308 100.624 92.8319 100.185 93.0883C100.448 93.1762 100.661 93.9306 100.734 94.2968C100.119 94.2089 99.8918 94.5531 99.8552 94.7362C103.722 97.4609 104.982 103.782 105.129 106.602H104.689C105.48 113.809 102.529 119.566 100.954 121.543C102.36 116.446 101.833 111.656 101.393 109.898C100.954 109.81 100.551 110.813 100.405 111.326C100.492 109.041 98.6101 105.027 97.6579 103.306C97.7312 103.965 97.7678 105.261 97.3283 105.173C96.8889 105.086 94.9479 101.035 94.0323 99.021C94.0323 99.7534 93.9664 101.218 93.7027 101.218Z",
    fill: "#214325"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4798 98.3882C83.7289 98.4302 90.9088 93.8603 92.0514 92.5708C96.7321 92.4576 103.092 89.7727 91.0849 79.9382C79.0778 70.1038 66.0382 75.684 61.0193 79.7033C65.6715 76.9303 72.9468 77.9763 76.0029 78.8459C75.8945 78.9823 75.8252 79.267 75.804 79.3923C80.1281 79.5799 82.1473 80.816 82.6165 81.4106C83.078 82.7257 82.363 82.9145 81.9477 82.8445C78.4021 82.0922 73.931 83.7486 72.1386 84.6709C72.4004 84.6377 72.562 84.9034 72.6101 85.0404C66.7375 87.453 63.953 90.7986 63.2948 92.1698L63.8138 92.2573C61.6022 95.7511 62.0578 98.6633 62.5621 99.6827C63.2929 96.8674 66.4693 94.026 67.9661 92.9573C67.7493 93.23 67.8769 93.9089 67.9678 94.2142C68.0692 93.6126 73.0353 90.7508 75.5057 89.395C75.2509 89.8934 75.2517 90.4799 75.2839 90.7109C80.837 88.1671 78.1494 90.111 78.5276 90.4003C78.2658 90.4335 77.9563 91.0451 77.8343 91.3467C78.4283 91.3695 78.5932 91.7002 78.6014 91.8627C74.5545 93.5778 72.4526 98.7848 71.9075 101.174L72.3228 101.244C70.536 107.284 72.4947 112.679 73.6974 114.622C73.1038 110.037 74.2929 106.023 74.9616 104.589C75.3895 104.584 75.6254 105.506 75.6899 105.968C75.9364 103.999 78.2938 100.865 79.4417 99.5441C79.2774 100.096 79.0558 101.2 79.4837 101.194C79.9116 101.189 82.3297 98.0332 83.4852 96.4558C83.3796 97.0824 83.2306 98.3462 83.4798 98.3882Z",
    fill: "#214325"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M532.868 206.292L385.203 76.1609L380.502 84.9684L336.258 207.425L532.868 206.292Z",
    fill: "url(#paint0_linear_19_525)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M335.038 206.961L278.944 172.994L385.203 76.161L335.038 206.961Z",
    fill: "url(#paint1_linear_19_525)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_525",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 336,
    y: 76,
    width: 197,
    height: 132
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M532.868 206.292L385.203 76.1609L380.502 84.9684L336.258 207.425L532.868 206.292Z",
    fill: "url(#paint2_linear_19_525)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_525)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_19_525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.227 208.413L243.197 8.48657L235.904 21.7019L141.916 213.611L450.227 208.413Z",
    fill: "black",
    fillOpacity: 0.24
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_19_525",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 278,
    y: 76,
    width: 108,
    height: 131
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M335.038 206.961L278.944 172.994L385.203 76.161L335.038 206.961Z",
    fill: "url(#paint3_linear_19_525)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_19_525)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_19_525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.227 208.413L243.197 8.48657L235.904 21.7019L141.916 213.611L450.227 208.413Z",
    fill: "black",
    fillOpacity: 0.24
  })))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M425.989 208.822L218.959 8.89526L211.666 22.1106L117.678 214.02L425.989 208.822Z",
    fill: "url(#paint4_linear_19_525)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_19_525",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 8,
    width: 309,
    height: 207
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M425.989 208.822L218.959 8.89526L211.666 22.1106L117.678 214.02L425.989 208.822Z",
    fill: "url(#paint5_linear_19_525)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_19_525)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_19_525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.176 210.622L28.5006 44.1101L20.4272 54.1868L-74.3218 215.317L204.176 210.622Z",
    fill: "black",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69.2277 215.474L-116.224 203.416L28.5006 44.1101L-69.2277 215.474Z",
    fill: "black",
    fillOpacity: 0.36
  })))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M130.177 193.201L69.1481 168.53L218.959 8.89539L130.177 193.201Z",
    fill: "url(#paint6_linear_19_525)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_19_525",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 8,
    width: 150,
    height: 186
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M130.177 193.201L69.1481 168.53L218.959 8.89539L130.177 193.201Z",
    fill: "url(#paint7_linear_19_525)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_19_525)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_19_525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.176 210.622L28.5004 44.1101L20.4269 54.1868L-74.3221 215.317L204.176 210.622Z",
    fill: "black",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69.2279 215.474L-116.224 203.416L28.5004 44.1101L-69.2279 215.474Z",
    fill: "black",
    fillOpacity: 0.36
  })))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M190.2 215.707L14.5244 49.1946L6.45093 59.2712L-88.2981 220.402L190.2 215.707Z",
    fill: "url(#paint8_linear_19_525)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M-83.204 220.559L-130.2 208.501L14.5243 49.1948L-83.204 220.559Z",
    fill: "url(#paint9_linear_19_525)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4041 159.769C45.0179 159.597 44.5096 153.4 43.9288 150.322L37.3942 149.034C36.6681 150.895 34.9982 155.131 34.1269 157.193C33.0378 159.769 39.1368 159.984 42.4041 159.769Z",
    fill: "#492E0D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4041 159.769C45.0179 159.597 44.5096 153.4 43.9288 150.322L37.3942 149.034C36.6681 150.895 34.9982 155.131 34.1269 157.193C33.0378 159.769 39.1368 159.984 42.4041 159.769Z",
    fill: "#492E0D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4041 159.769C45.0179 159.597 44.5096 153.4 43.9288 150.322L37.3942 149.034C36.6681 150.895 34.9982 155.131 34.1269 157.193C33.0378 159.769 39.1368 159.984 42.4041 159.769Z",
    fill: "#492E0D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4041 159.769C45.0179 159.597 44.5096 153.4 43.9288 150.322L37.3942 149.034C36.6681 150.895 34.9982 155.131 34.1269 157.193C33.0378 159.769 39.1368 159.984 42.4041 159.769Z",
    fill: "#492E0D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2229 166.693C43.8145 166.311 42.8097 160.174 41.9833 157.154L35.3663 156.395C34.7922 158.308 33.4682 162.665 32.7655 164.79C31.887 167.446 37.9835 167.169 41.2229 166.693Z",
    fill: "#492E0D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2229 166.693C43.8145 166.311 42.8097 160.174 41.9833 157.154L35.3663 156.395C34.7922 158.308 33.4682 162.665 32.7655 164.79C31.887 167.446 37.9835 167.169 41.2229 166.693Z",
    fill: "#492E0D"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2229 166.693C43.8145 166.311 42.8097 160.174 41.9833 157.154L35.3663 156.395C34.7922 158.308 33.4682 162.665 32.7655 164.79C31.887 167.446 37.9835 167.169 41.2229 166.693Z",
    fill: "#492E0D"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2229 166.693C43.8145 166.311 42.8097 160.174 41.9833 157.154L35.3663 156.395C34.7922 158.308 33.4682 162.665 32.7655 164.79C31.887 167.446 37.9835 167.169 41.2229 166.693Z",
    fill: "#492E0D"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1643 174.809C43.0702 174.382 41.9435 167.501 41.0169 164.113L33.5971 163.263C32.9533 165.408 31.4687 170.294 30.6807 172.676C29.6957 175.654 36.5318 175.344 40.1643 174.809Z",
    fill: "#492E0D"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1643 174.809C43.0702 174.382 41.9435 167.501 41.0169 164.113L33.5971 163.263C32.9533 165.408 31.4687 170.294 30.6807 172.676C29.6957 175.654 36.5318 175.344 40.1643 174.809Z",
    fill: "#492E0D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1643 174.809C43.0702 174.382 41.9435 167.501 41.0169 164.113L33.5971 163.263C32.9533 165.408 31.4687 170.294 30.6807 172.676C29.6957 175.654 36.5318 175.344 40.1643 174.809Z",
    fill: "#492E0D"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1643 174.809C43.0702 174.382 41.9435 167.501 41.0169 164.113L33.5971 163.263C32.9533 165.408 31.4687 170.294 30.6807 172.676C29.6957 175.654 36.5318 175.344 40.1643 174.809Z",
    fill: "#492E0D"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2195 183.598C42.314 183.143 41.1142 175.815 40.1275 172.208L32.2262 171.302C31.5407 173.586 29.9598 178.789 29.1206 181.326C28.0717 184.497 35.3514 184.167 39.2195 183.598Z",
    fill: "#492E0D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2195 183.598C42.314 183.143 41.1142 175.815 40.1275 172.208L32.2262 171.302C31.5407 173.586 29.9598 178.789 29.1206 181.326C28.0717 184.497 35.3514 184.167 39.2195 183.598Z",
    fill: "#492E0D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2195 183.598C42.314 183.143 41.1142 175.815 40.1275 172.208L32.2262 171.302C31.5407 173.586 29.9598 178.789 29.1206 181.326C28.0717 184.497 35.3514 184.167 39.2195 183.598Z",
    fill: "#492E0D"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2195 183.598C42.314 183.143 41.1142 175.815 40.1275 172.208L32.2262 171.302C31.5407 173.586 29.9598 178.789 29.1206 181.326C28.0717 184.497 35.3514 184.167 39.2195 183.598Z",
    fill: "#492E0D"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4315 194.513C42.0311 193.984 40.6355 185.46 39.4877 181.264L30.2967 180.21C29.4993 182.867 27.6603 188.92 26.6842 191.87C25.4641 195.559 33.932 195.175 38.4315 194.513Z",
    fill: "#492E0D"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4315 194.513C42.0311 193.984 40.6355 185.46 39.4877 181.264L30.2967 180.21C29.4993 182.867 27.6603 188.92 26.6842 191.87C25.4641 195.559 33.932 195.175 38.4315 194.513Z",
    fill: "#492E0D"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4315 194.513C42.0311 193.984 40.6355 185.46 39.4877 181.264L30.2967 180.21C29.4993 182.867 27.6603 188.92 26.6842 191.87C25.4641 195.559 33.932 195.175 38.4315 194.513Z",
    fill: "#492E0D"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4315 194.513C42.0311 193.984 40.6355 185.46 39.4877 181.264L30.2967 180.21C29.4993 182.867 27.6603 188.92 26.6842 191.87C25.4641 195.559 33.932 195.175 38.4315 194.513Z",
    fill: "#492E0D"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M38.239 205.376C42.0564 204.472 39.7643 195.446 38.1411 191.045L28.1702 190.768C27.5607 193.697 26.1483 200.369 25.3743 203.63C24.4067 207.705 33.4672 206.506 38.239 205.376Z",
    fill: "#492E0D"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M38.239 205.376C42.0564 204.472 39.7643 195.446 38.1411 191.045L28.1702 190.768C27.5607 193.697 26.1483 200.369 25.3743 203.63C24.4067 207.705 33.4672 206.506 38.239 205.376Z",
    fill: "#492E0D"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M38.239 205.376C42.0564 204.472 39.7643 195.446 38.1411 191.045L28.1702 190.768C27.5607 193.697 26.1483 200.369 25.3743 203.63C24.4067 207.705 33.4672 206.506 38.239 205.376Z",
    fill: "#492E0D"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M38.239 205.376C42.0564 204.472 39.7643 195.446 38.1411 191.045L28.1702 190.768C27.5607 193.697 26.1483 200.369 25.3743 203.63C24.4067 207.705 33.4672 206.506 38.239 205.376Z",
    fill: "#492E0D"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0788 218.343C43.333 217.045 40.0899 206.997 37.9365 202.135L26.6349 202.539C26.1561 205.897 25.0383 213.548 24.3972 217.293C23.5959 221.974 33.7611 219.964 39.0788 218.343Z",
    fill: "#492E0D"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0788 218.343C43.333 217.045 40.0899 206.997 37.9365 202.135L26.6349 202.539C26.1561 205.897 25.0383 213.548 24.3972 217.293C23.5959 221.974 33.7611 219.964 39.0788 218.343Z",
    fill: "#492E0D"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0788 218.343C43.333 217.045 40.0899 206.997 37.9365 202.135L26.6349 202.539C26.1561 205.897 25.0383 213.548 24.3972 217.293C23.5959 221.974 33.7611 219.964 39.0788 218.343Z",
    fill: "#492E0D"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0788 218.343C43.333 217.045 40.0899 206.997 37.9365 202.135L26.6349 202.539C26.1561 205.897 25.0383 213.548 24.3972 217.293C23.5959 221.974 33.7611 219.964 39.0788 218.343Z",
    fill: "#492E0D"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3345 231.545C43.7737 230.192 40.3895 219.707 38.1425 214.633L26.3497 215.055C25.8501 218.559 24.6837 226.542 24.0147 230.45C23.1785 235.335 33.7856 233.238 39.3345 231.545Z",
    fill: "#492E0D"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3345 231.545C43.7737 230.192 40.3895 219.707 38.1425 214.633L26.3497 215.055C25.8501 218.559 24.6837 226.542 24.0147 230.45C23.1785 235.335 33.7856 233.238 39.3345 231.545Z",
    fill: "#492E0D"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3345 231.545C43.7737 230.192 40.3895 219.707 38.1425 214.633L26.3497 215.055C25.8501 218.559 24.6837 226.542 24.0147 230.45C23.1785 235.335 33.7856 233.238 39.3345 231.545Z",
    fill: "#492E0D"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3345 231.545C43.7737 230.192 40.3895 219.707 38.1425 214.633L26.3497 215.055C25.8501 218.559 24.6837 226.542 24.0147 230.45C23.1785 235.335 33.7856 233.238 39.3345 231.545Z",
    fill: "#492E0D"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1874 246.672C44.886 245.239 41.304 234.142 38.9257 228.772L26.4435 229.218C25.9147 232.926 24.6801 241.377 23.972 245.513C23.0869 250.683 34.3141 248.463 40.1874 246.672Z",
    fill: "#492E0D"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1874 246.672C44.886 245.239 41.304 234.142 38.9257 228.772L26.4435 229.218C25.9147 232.926 24.6801 241.377 23.972 245.513C23.0869 250.683 34.3141 248.463 40.1874 246.672Z",
    fill: "#492E0D"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1874 246.672C44.886 245.239 41.304 234.142 38.9257 228.772L26.4435 229.218C25.9147 232.926 24.6801 241.377 23.972 245.513C23.0869 250.683 34.3141 248.463 40.1874 246.672Z",
    fill: "#492E0D"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1874 246.672C44.886 245.239 41.304 234.142 38.9257 228.772L26.4435 229.218C25.9147 232.926 24.6801 241.377 23.972 245.513C23.0869 250.683 34.3141 248.463 40.1874 246.672Z",
    fill: "#492E0D"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8008 262.854C45.2388 261.812 42.5562 248.945 40.5352 242.641L26.4923 241.643C25.4546 245.736 23.0568 255.058 21.7667 259.609C20.1542 265.297 33.0034 264.157 39.8008 262.854Z",
    fill: "#492E0D"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8008 262.854C45.2388 261.812 42.5562 248.945 40.5352 242.641L26.4923 241.643C25.4546 245.736 23.0568 255.058 21.7667 259.609C20.1542 265.297 33.0034 264.157 39.8008 262.854Z",
    fill: "#492E0D"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8008 262.854C45.2388 261.812 42.5562 248.945 40.5352 242.641L26.4923 241.643C25.4546 245.736 23.0568 255.058 21.7667 259.609C20.1542 265.297 33.0034 264.157 39.8008 262.854Z",
    fill: "#492E0D"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8008 262.854C45.2388 261.812 42.5562 248.945 40.5352 242.641L26.4923 241.643C25.4546 245.736 23.0568 255.058 21.7667 259.609C20.1542 265.297 33.0034 264.157 39.8008 262.854Z",
    fill: "#492E0D"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5955 160.569C49.1156 160.569 45.5296 154.437 43.7966 151.371C35.0648 149.505 24.0002 141.733 49.5955 125.576C75.1907 109.419 97.8531 125.509 105.985 135.574C98.1463 128.216 84.1889 127.842 78.1901 128.575C78.35 128.895 78.39 129.509 78.39 129.775C70.2315 128.655 66.059 130.508 64.9925 131.575C63.7128 134.134 64.9925 134.774 65.7924 134.774C72.6711 134.454 80.523 139.44 83.5891 141.973C83.1091 141.813 82.7225 142.306 82.5892 142.573C92.8273 149.611 96.9865 157.503 97.7864 160.569H96.7867C99.8261 168.568 98.0531 174.434 96.7867 176.366C96.3067 170.288 91.2543 163.302 88.788 160.569C89.108 161.209 88.6547 162.569 88.3881 163.169C88.3881 161.889 79.9897 154.237 75.7905 150.571C76.1105 151.691 75.9239 152.904 75.7905 153.371C66.1923 146.172 62.1931 145.306 61.3932 145.772C61.8731 145.932 62.2597 147.305 62.3931 147.972C61.2733 147.812 60.86 148.438 60.7934 148.772C67.832 153.731 70.1249 165.235 70.3916 170.368H69.5917C71.0314 183.485 65.6591 193.963 62.793 197.563C65.3525 188.284 64.3927 179.566 63.5928 176.366C62.793 176.207 62.0598 178.033 61.7932 178.966C61.9532 174.807 58.5271 167.501 56.7941 164.369C56.9274 165.569 56.9941 167.928 56.1942 167.768C55.3944 167.608 51.8617 160.236 50.1954 156.57C50.1954 157.903 50.0754 160.569 49.5955 160.569Z",
    fill: "#214325"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9889 155.418C31.4424 155.495 44.5102 147.177 46.5898 144.83C55.1091 144.624 66.6844 139.738 44.8307 121.838C22.9771 103.939 -0.755859 114.095 -9.89064 121.411C-1.42319 116.364 11.8183 118.267 17.3806 119.85C17.1833 120.098 17.0571 120.617 17.0186 120.845C24.8886 121.186 28.5639 123.436 29.4177 124.518C30.2578 126.912 28.9563 127.255 28.2006 127.128C21.7474 125.759 13.6095 128.773 10.3472 130.452C10.8238 130.392 11.1179 130.875 11.2054 131.125C0.516876 135.516 -4.55109 141.605 -5.74899 144.101L-4.80438 144.26C-8.82969 150.619 -8.00036 155.919 -7.08253 157.775C-5.75243 152.65 0.0287552 147.479 2.75309 145.534C2.35851 146.03 2.59068 147.266 2.75608 147.821C2.94064 146.727 11.9794 141.518 16.4757 139.05C16.0119 139.957 16.0133 141.025 16.0719 141.445C26.1789 136.815 21.2873 140.353 21.9758 140.88C21.4993 140.94 20.936 142.054 20.7139 142.603C21.795 142.644 22.0951 143.246 22.11 143.542C14.7444 146.663 10.9188 156.14 9.92672 160.489L10.6825 160.616C7.43043 171.609 10.9954 181.429 13.1844 184.965C12.104 176.619 14.2682 169.314 15.4854 166.704C16.2642 166.694 16.6935 168.374 16.8109 169.214C17.2595 165.631 21.5501 159.926 23.6394 157.522C23.3404 158.527 22.9371 160.535 23.7159 160.526C24.4948 160.517 28.8957 154.772 30.9989 151.901C30.8066 153.042 30.5355 155.342 30.9889 155.418Z",
    fill: "#214325"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M423.484 92.6404C420.227 92.4264 420.861 84.7054 421.584 80.8717L429.725 79.2668C430.629 81.5849 432.71 86.863 433.795 89.4308C435.152 92.6404 427.554 92.9079 423.484 92.6404Z",
    fill: "#492E0D"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M423.484 92.6404C420.227 92.4264 420.861 84.7054 421.584 80.8717L429.725 79.2668C430.629 81.5849 432.71 86.863 433.795 89.4308C435.152 92.6404 427.554 92.9079 423.484 92.6404Z",
    fill: "#492E0D"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M423.484 92.6404C420.227 92.4264 420.861 84.7054 421.584 80.8717L429.725 79.2668C430.629 81.5849 432.71 86.863 433.795 89.4308C435.152 92.6404 427.554 92.9079 423.484 92.6404Z",
    fill: "#492E0D"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M423.484 92.6404C420.227 92.4264 420.861 84.7054 421.584 80.8717L429.725 79.2668C430.629 81.5849 432.71 86.863 433.795 89.4308C435.152 92.6404 427.554 92.9079 423.484 92.6404Z",
    fill: "#492E0D"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M424.955 101.266C421.727 100.791 422.978 93.1456 424.008 89.3824L432.251 88.4372C432.966 90.8205 434.616 96.2487 435.491 98.8954C436.586 102.204 428.991 101.86 424.955 101.266Z",
    fill: "#492E0D"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M424.955 101.266C421.727 100.791 422.978 93.1456 424.008 89.3824L432.251 88.4372C432.966 90.8205 434.616 96.2487 435.491 98.8954C436.586 102.204 428.991 101.86 424.955 101.266Z",
    fill: "#492E0D"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M424.955 101.266C421.727 100.791 422.978 93.1456 424.008 89.3824L432.251 88.4372C432.966 90.8205 434.616 96.2487 435.491 98.8954C436.586 102.204 428.991 101.86 424.955 101.266Z",
    fill: "#492E0D"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M424.955 101.266C421.727 100.791 422.978 93.1456 424.008 89.3824L432.251 88.4372C432.966 90.8205 434.616 96.2487 435.491 98.8954C436.586 102.204 428.991 101.86 424.955 101.266Z",
    fill: "#492E0D"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M426.274 111.378C422.654 110.845 424.057 102.272 425.212 98.0526L434.455 96.9927C435.257 99.6651 437.107 105.752 438.088 108.72C439.316 112.429 430.799 112.044 426.274 111.378Z",
    fill: "#492E0D"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M426.274 111.378C422.654 110.845 424.057 102.272 425.212 98.0526L434.455 96.9927C435.257 99.6651 437.107 105.752 438.088 108.72C439.316 112.429 430.799 112.044 426.274 111.378Z",
    fill: "#492E0D"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M426.274 111.378C422.654 110.845 424.057 102.272 425.212 98.0526L434.455 96.9927C435.257 99.6651 437.107 105.752 438.088 108.72C439.316 112.429 430.799 112.044 426.274 111.378Z",
    fill: "#492E0D"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M426.274 111.378C422.654 110.845 424.057 102.272 425.212 98.0526L434.455 96.9927C435.257 99.6651 437.107 105.752 438.088 108.72C439.316 112.429 430.799 112.044 426.274 111.378Z",
    fill: "#492E0D"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M427.451 122.327C423.596 121.759 425.09 112.63 426.32 108.137L436.163 107.008C437.017 109.854 438.987 116.336 440.032 119.496C441.339 123.447 432.27 123.036 427.451 122.327Z",
    fill: "#492E0D"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M427.451 122.327C423.596 121.759 425.09 112.63 426.32 108.137L436.163 107.008C437.017 109.854 438.987 116.336 440.032 119.496C441.339 123.447 432.27 123.036 427.451 122.327Z",
    fill: "#492E0D"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M427.451 122.327C423.596 121.759 425.09 112.63 426.32 108.137L436.163 107.008C437.017 109.854 438.987 116.336 440.032 119.496C441.339 123.447 432.27 123.036 427.451 122.327Z",
    fill: "#492E0D"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M427.451 122.327C423.596 121.759 425.09 112.63 426.32 108.137L436.163 107.008C437.017 109.854 438.987 116.336 440.032 119.496C441.339 123.447 432.27 123.036 427.451 122.327Z",
    fill: "#492E0D"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M428.433 135.924C423.948 135.265 425.687 124.646 427.117 119.419L438.567 118.106C439.56 121.416 441.851 128.956 443.067 132.632C444.587 137.227 434.038 136.749 428.433 135.924Z",
    fill: "#492E0D"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M428.433 135.924C423.948 135.265 425.687 124.646 427.117 119.419L438.567 118.106C439.56 121.416 441.851 128.956 443.067 132.632C444.587 137.227 434.038 136.749 428.433 135.924Z",
    fill: "#492E0D"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M428.433 135.924C423.948 135.265 425.687 124.646 427.117 119.419L438.567 118.106C439.56 121.416 441.851 128.956 443.067 132.632C444.587 137.227 434.038 136.749 428.433 135.924Z",
    fill: "#492E0D"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M428.433 135.924C423.948 135.265 425.687 124.646 427.117 119.419L438.567 118.106C439.56 121.416 441.851 128.956 443.067 132.632C444.587 137.227 434.038 136.749 428.433 135.924Z",
    fill: "#492E0D"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M428.672 149.457C423.917 148.331 426.772 137.086 428.794 131.604L441.216 131.259C441.975 134.907 443.735 143.219 444.699 147.281C445.904 152.359 434.617 150.864 428.672 149.457Z",
    fill: "#492E0D"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M428.672 149.457C423.917 148.331 426.772 137.086 428.794 131.604L441.216 131.259C441.975 134.907 443.735 143.219 444.699 147.281C445.904 152.359 434.617 150.864 428.672 149.457Z",
    fill: "#492E0D"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M428.672 149.457C423.917 148.331 426.772 137.086 428.794 131.604L441.216 131.259C441.975 134.907 443.735 143.219 444.699 147.281C445.904 152.359 434.617 150.864 428.672 149.457Z",
    fill: "#492E0D"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M428.672 149.457C423.917 148.331 426.772 137.086 428.794 131.604L441.216 131.259C441.975 134.907 443.735 143.219 444.699 147.281C445.904 152.359 434.617 150.864 428.672 149.457Z",
    fill: "#492E0D"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M427.626 165.611C422.326 163.994 426.367 151.477 429.049 145.42L443.129 145.923C443.725 150.106 445.118 159.638 445.916 164.303C446.915 170.135 434.251 167.631 427.626 165.611Z",
    fill: "#492E0D"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M427.626 165.611C422.326 163.994 426.367 151.477 429.049 145.42L443.129 145.923C443.725 150.106 445.118 159.638 445.916 164.303C446.915 170.135 434.251 167.631 427.626 165.611Z",
    fill: "#492E0D"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M427.626 165.611C422.326 163.994 426.367 151.477 429.049 145.42L443.129 145.923C443.725 150.106 445.118 159.638 445.916 164.303C446.915 170.135 434.251 167.631 427.626 165.611Z",
    fill: "#492E0D"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M427.626 165.611C422.326 163.994 426.367 151.477 429.049 145.42L443.129 145.923C443.725 150.106 445.118 159.638 445.916 164.303C446.915 170.135 434.251 167.631 427.626 165.611Z",
    fill: "#492E0D"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M427.308 182.058C421.777 180.372 425.993 167.31 428.793 160.99L443.484 161.515C444.106 165.88 445.559 175.826 446.393 180.694C447.435 186.779 434.22 184.167 427.308 182.058Z",
    fill: "#492E0D"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M427.308 182.058C421.777 180.372 425.993 167.31 428.793 160.99L443.484 161.515C444.106 165.88 445.559 175.826 446.393 180.694C447.435 186.779 434.22 184.167 427.308 182.058Z",
    fill: "#492E0D"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M427.308 182.058C421.777 180.372 425.993 167.31 428.793 160.99L443.484 161.515C444.106 165.88 445.559 175.826 446.393 180.694C447.435 186.779 434.22 184.167 427.308 182.058Z",
    fill: "#492E0D"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M427.308 182.058C421.777 180.372 425.993 167.31 428.793 160.99L443.484 161.515C444.106 165.88 445.559 175.826 446.393 180.694C447.435 186.779 434.22 184.167 427.308 182.058Z",
    fill: "#492E0D"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M426.245 200.903C420.392 199.118 424.854 185.293 427.817 178.603L443.367 179.159C444.026 183.779 445.564 194.306 446.446 199.459C447.549 205.9 433.562 203.135 426.245 200.903Z",
    fill: "#492E0D"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M426.245 200.903C420.392 199.118 424.854 185.293 427.817 178.603L443.367 179.159C444.026 183.779 445.564 194.306 446.446 199.459C447.549 205.9 433.562 203.135 426.245 200.903Z",
    fill: "#492E0D"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M426.245 200.903C420.392 199.118 424.854 185.293 427.817 178.603L443.367 179.159C444.026 183.779 445.564 194.306 446.446 199.459C447.549 205.9 433.562 203.135 426.245 200.903Z",
    fill: "#492E0D"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M426.245 200.903C420.392 199.118 424.854 185.293 427.817 178.603L443.367 179.159C444.026 183.779 445.564 194.306 446.446 199.459C447.549 205.9 433.562 203.135 426.245 200.903Z",
    fill: "#492E0D"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M426.727 221.063C419.952 219.765 423.294 203.734 425.812 195.881L443.306 194.638C444.599 199.737 447.586 211.351 449.193 217.02C451.202 224.106 435.195 222.686 426.727 221.063Z",
    fill: "#492E0D"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M426.727 221.063C419.952 219.765 423.294 203.734 425.812 195.881L443.306 194.638C444.599 199.737 447.586 211.351 449.193 217.02C451.202 224.106 435.195 222.686 426.727 221.063Z",
    fill: "#492E0D"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M426.727 221.063C419.952 219.765 423.294 203.734 425.812 195.881L443.306 194.638C444.599 199.737 447.586 211.351 449.193 217.02C451.202 224.106 435.195 222.686 426.727 221.063Z",
    fill: "#492E0D"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M426.727 221.063C419.952 219.765 423.294 203.734 425.812 195.881L443.306 194.638C444.599 199.737 447.586 211.351 449.193 217.02C451.202 224.106 435.195 222.686 426.727 221.063Z",
    fill: "#492E0D"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M414.525 93.6376C415.122 93.6376 419.59 85.9982 421.749 82.1785C432.627 79.8535 446.411 70.1714 414.525 50.0432C382.638 29.9151 354.406 49.9602 344.275 62.4988C354.041 53.3315 371.428 52.8665 378.902 53.7799C378.702 54.1785 378.653 54.9424 378.653 55.2745C388.816 53.8795 394.014 56.1879 395.343 57.5165C396.937 60.7052 395.343 61.5023 394.347 61.5023C385.777 61.1037 375.995 67.3149 372.176 70.4703C372.774 70.271 373.255 70.8855 373.421 71.2176C360.667 79.9863 355.485 89.8179 354.489 93.6376H355.734C351.948 103.602 354.157 110.909 355.734 113.317C356.332 105.744 362.627 97.0421 365.699 93.6376C365.3 94.4347 365.865 96.1287 366.197 96.876C366.197 95.2817 376.66 85.7491 381.891 81.182C381.492 82.5771 381.725 84.0883 381.891 84.6696C393.848 75.7016 398.831 74.6221 399.827 75.2034C399.229 75.4027 398.748 77.1132 398.581 77.9436C399.976 77.7443 400.491 78.5249 400.574 78.94C391.806 85.118 388.949 99.4501 388.617 105.844H389.614C387.82 122.186 394.513 135.239 398.083 139.723C394.895 128.164 396.09 117.303 397.087 113.317C398.083 113.118 398.997 115.393 399.329 116.556C399.129 111.374 403.398 102.273 405.557 98.3707C405.39 99.8653 405.307 102.805 406.304 102.606C407.3 102.406 411.701 93.2224 413.777 88.6554C413.777 90.3161 413.927 93.6376 414.525 93.6376Z",
    fill: "#214325"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M437.704 87.2205C437.139 87.3157 420.86 76.954 418.269 74.03C407.656 73.7734 393.235 67.6855 420.46 45.3869C447.685 23.0882 477.251 35.7407 488.631 44.8542C478.083 38.5667 461.587 40.9383 454.657 42.91C454.903 43.2192 455.06 43.8649 455.108 44.149C445.304 44.5743 440.725 47.3772 439.662 48.7254C438.615 51.7073 440.236 52.1353 441.178 51.9766C449.217 50.2708 459.355 54.0266 463.419 56.1178C462.826 56.0425 462.459 56.6449 462.35 56.9555C475.666 62.4259 481.98 70.0118 483.472 73.1209L482.295 73.3193C487.31 81.241 486.277 87.8444 485.133 90.1558C483.476 83.7722 476.274 77.3297 472.88 74.9064C473.372 75.5249 473.082 77.064 472.876 77.7563C472.646 76.3923 461.386 69.9033 455.785 66.8293C456.363 67.9593 456.361 69.2893 456.288 69.813C443.697 64.0451 449.79 68.4527 448.933 69.1087C449.526 69.184 450.228 70.5707 450.505 71.2546C449.158 71.3063 448.784 72.0561 448.765 72.4245C457.942 76.3133 462.707 88.1199 463.943 93.537L463.002 93.6958C467.053 107.391 462.612 119.624 459.885 124.029C461.231 113.632 458.535 104.531 457.018 101.28C456.048 101.268 455.513 103.36 455.367 104.407C454.808 99.9426 449.463 92.8364 446.86 89.8414C447.233 91.0937 447.735 93.5953 446.765 93.5835C445.795 93.5717 440.312 86.4156 437.692 82.839C437.931 84.2598 438.269 87.1252 437.704 87.2205Z",
    fill: "#214325"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_19_525",
    x: 119.917,
    y: -13.5134,
    width: 352.311,
    height: 249.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    result: "effect1_foregroundBlur_19_525"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_19_525",
    x: 119.917,
    y: -13.5134,
    width: 352.311,
    height: 249.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    result: "effect1_foregroundBlur_19_525"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_19_525",
    x: -153.224,
    y: 7.11011,
    width: 394.4,
    height: 245.364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.5,
    result: "effect1_foregroundBlur_19_525"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_19_525",
    x: -153.224,
    y: 7.11011,
    width: 394.4,
    height: 245.364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.5,
    result: "effect1_foregroundBlur_19_525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19_525",
    x1: 348.4,
    y1: 136.667,
    x2: 574.803,
    y2: 220.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1A360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FCF8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCEA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19_525",
    x1: 373.399,
    y1: 116.759,
    x2: 301.649,
    y2: 145.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE964B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C57E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19_525",
    x1: 348.4,
    y1: 136.667,
    x2: 574.803,
    y2: 220.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1A360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FCF8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCEA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_19_525",
    x1: 373.399,
    y1: 116.759,
    x2: 301.649,
    y2: 145.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE964B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C57E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_19_525",
    x1: 175.712,
    y1: 104.181,
    x2: 497.571,
    y2: 241.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1A360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FCF8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCEA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_19_525",
    x1: 175.712,
    y1: 104.181,
    x2: 497.571,
    y2: 241.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1A360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FCF8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCEA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_19_525",
    x1: 197.521,
    y1: 74.7188,
    x2: 98.3086,
    y2: 114.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE964B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C57E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_19_525",
    x1: 197.521,
    y1: 74.7188,
    x2: 98.3086,
    y2: 114.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE964B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C57E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_19_525",
    x1: -30.2643,
    y1: 110.563,
    x2: 207.167,
    y2: 215.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1A360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FFDABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF3ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_19_525",
    x1: -6.91393,
    y1: 115.018,
    x2: -106.126,
    y2: 155.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE964B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C57E42"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSceneryLight);
export default __webpack_public_path__ + "static/media/SceneryLight.e5b6100fe0995e5fda196f6f5f6fe3a5.svg";
export { ForwardRef as ReactComponent };